module.exports = __webpack_public_path__ + "img/chat-favourite.342f2d1a.svg";